import React from 'react';
import styled from '@emotion/styled';
import Img from 'gatsby-image';

import respond from '../../styles/mediaQueries';

const StyledImageContainer = styled('figure')`
    display: flex;
	margin: 12rem auto 0 auto;
	
	${respond('bp4')} {
		margin: 8rem auto 0 auto;
	}
`;

const Wrapper = styled('div')`
	height: auto;
    width: 100%;
	max-width: 96rem;
	max-height: 60rem;

	${respond('bp2')} {
		max-height: 52rem;
	}

	${respond('bp3')} {
		max-height: 40rem;
	}
`;

const CaseStudyImage = ({ fluid, alt, border, children }) => {
	return (
		<StyledImageContainer className='image-container'>
			<Wrapper
				style={{
					border: border ? '.3rem solid var(--bgSecondary)' : 'none'
				}}>
				{fluid && (
					<Img
						fluid={fluid}
						alt={alt}
						imgStyle={{
							objectFit: 'contain',
							maxHeight: 'auto',
							display: 'block'
						}}
						style={{ maxHeight: '100%' }}
					/>
				)}
				{children}
			</Wrapper>
		</StyledImageContainer>
	);
};

export default CaseStudyImage;
